import HomePage from "views/Pages/HomePage.jsx";
import ContentPage from "views/Pages/ContentPage.jsx";

// @material-ui/icons
import LockOpen from "@material-ui/icons/LockOpen";

const contentRoutes = [
  {
    path: "/privacy-policy",
    name: "Privacy Policy Page",
    short: "Lock",
    mini: "LSP",
    icon: LockOpen,
    dontShowInHeader: true,
    component: ContentPage
  },
  {
    path: "/terms-and-conditions",
    name: "Terms and Conditions Page",
    short: "Lock",
    mini: "LSP",
    icon: LockOpen,
    dontShowInHeader: true,
    component: ContentPage
  },
  {
    path: "/",
    name: "Home Page",
    short: "Lock",
    mini: "LSP",
    icon: LockOpen,
    dontShowInHeader: true,
    dontShowInSidebar: true,
    component: HomePage
  },  
];

export default contentRoutes;


// WEBPACK FOOTER //
// ./src/routes/content.jsx